"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var Exports_1 = require("./Exports");
var GlobalContext_1 = require("../Context/GlobalContext");
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Layout.prototype.render = function () {
        var _this = this;
        return (React.createElement(GlobalContext_1.GlobalConsumer, null, function (context) { return context && (React.createElement("div", null,
            React.createElement(Exports_1.Header, { resources: context.resources }),
            React.createElement(reactstrap_1.Container, null,
                React.createElement(Exports_1.LogoHeader, { siteLogo: _this.props.siteLogo, companyLogo: _this.props.companyLogo, supportedLanguages: context.supportedLanguages }),
                _this.props.children),
            React.createElement(Exports_1.CopyrightFooter, { resources: context.resources, version: context.version }),
            React.createElement("div", { style: { height: "2.25em", width: "100%", marginTop: "1em" } }))); }));
    };
    return Layout;
}(React.Component));
exports.Layout = Layout;
//# sourceMappingURL=Layout.js.map